import { auth } from "../config";

export const createUser = (email, password) => {
  return auth.createUserWithEmailAndPassword(email, password);
};

export const signInWithEmailAndPassword = (email, password) => {
  return auth.signInWithEmailAndPassword(email, password);
};

export const logout = () => {
  return auth.signOut();
};

export const passwordReset = email => {
  return auth.sendPasswordResetEmail(email);
};

export const updateProfile = profile => {
  const user = auth.currentUser;
  return user.updateProfile(profile);
};

// save user data to firestore
/*
export const saveUser = data => {
  const collectionName = 'users'
  const ref = dataStore.collection(collectionName)
  return ref.doc(data.uid).set({ ...data })
} */



// WEBPACK FOOTER //
// ./src/utils/fb.js